
















































































































import { Component, Vue } from 'vue-property-decorator';
import { StepsKeys } from '@/plugins/podolib/services/analysis';

@Component
export default class LayoutAnalysis extends Vue {
  // Flag to indicate if the recovery of entities' data from the api is in progress.
  recoveryInProgress = false;

  // Error
  error: Error | null = null;

  quitDialog = false;
  waitCancel = false;

  /**
   * Get patient id from route query
   */
  get patientId() {
    return this.$route.query?.patientId as string;
  }

  get patient() {
    return this.$pdc.analysis!.entityPatient;
  }

  get stations() {
    return this.$pdc.analysis!.entityStations;
  }

  /**
   * Manifest entry of "analysis" step
   */
  get stepAnalysis() {
    return this.$pdc.analysis!.getManifestEntry(StepsKeys.Analysis);
  }

  get anotherProcessRunning() {
    return this.$pdc.analysis!.entityCommand && this.$pdc.analysis!.entityCommand?.patientId !== this.patientId;
  }

  get stationIsOffline() {
    const stepStation = this.$pdc.analysis!.getManifestEntry(StepsKeys.Station);
    const entityStations = this.$pdc.analysis!.entityStations;

    if ([StepsKeys.SolesPair, StepsKeys.Analysis].includes(this.$pdc.analysis!.currentStepKey)) {
      return !entityStations?.data.find((station) => station._id === stepStation.stationId && station.online);
    }

    return false;
  }

  async checkAndSetup() {
    this.error = null;

    // Check if a patient id is available in route query
    if (!this.patientId) {
      this.error = new Error('Query is invalid');
      return;
    }

    // Start analysis service
    // this.$pdc.analysis!.start();

    if (
      this.$pdc.analysis!.patientId &&
      this.$pdc.analysis!.patientId !== this.patientId &&
      this.$pdc.analysis!.manifestIsTouched
    ) {
      this.error = new Error('Another analysis pending');
      return;
    }

    if (this.$pdc.analysis!.patientId === this.patientId) return;

    try {
      // Reset "error"
      this.error = null;

      // Up "recoveryInProgress" flag
      this.recoveryInProgress = true;

      // Configure service with patient target
      await this.$pdc.analysis!.configurePatient(this.patientId);

      if (this.$route.query?.degradedActivity) {
        console.log('have degradedActivity');
        this.goToAnalysisStep();
      }

      // this.$pdc.analysis?.useDebugManifest();
    } catch (e) {
      // Set "error"
      this.error = e;
    } finally {
      // Down "recoveryInProgress" flag
      this.recoveryInProgress = false;
    }

    // TODO : ⚠ REMOVE BEFORE RELEASE ⚠
    /*this.$nextTick(() => {
      this.$pdc.analysis!.useDebugManifest();
    });*/
  }

  /*@Watch('quitDialog')
  onQuitDialogChanged(newState: boolean) {
    if (newState) {
      this.$pdc.bus!.on('analysis:step-analysis:cancelled', this.quit);
    } else {
      this.$pdc.bus!.off('analysis:step-analysis:cancelled', this.quit);
    }
  }*/

  quit() {
    // this.$router.push({ path: `/patient/${this.$pdc.analysis!.patientId}` });
    if (this.$pdc.analysis!.manifestIsTouched) {
      this.quitDialog = true;
    } else {
      this.redirect();
    }
  }

  async cancelAndQuit() {
    this.waitCancel = true;

    await this.$pdc.analysis!.cancelAnalysis();

    this.redirect();

    this.$pdc.analysis!.clean();
  }

  redirect() {
    this.$router.push({ path: `/patient/${this.$pdc.analysis!.patientId}` });
  }

  returnToStationStep() {
    this.$pdc.analysis!.currentStepKey = StepsKeys.Station;
    this.$pdc.analysis!.setPropertyInManifestEntry(StepsKeys.Station, 'stationId', null);
  }

  goToAnalysisStep() {
    const activity: any = this.$route.query?.degradedActivity;

    this.$pdc.analysis!.setManifestEntry(StepsKeys.Type, activity.type);
    if (activity.conditions) this.$pdc.analysis!.setManifestEntry(StepsKeys.Conditions, activity.conditions);

    if (this.$pdc.analysis!.entityStations && this.$pdc.analysis!.entityStations.data.length > 1) {
      this.$pdc.analysis!.currentStepKey = StepsKeys.Station;
    } else {
      this.$pdc.analysis!.setManifestEntry(StepsKeys.Station, activity.station);
      this.$pdc.analysis!.currentStepKey = StepsKeys.SolesPair;
    }
  }

  /*cancelAndQuit() {
    this.waitCancel = true;
    this.$pdc.bus!.emitDebug('analysis:step-analysis:cancel');
  }*/

  /*quit() {
    this.$pdc.bus!.off('analysis:step-analysis:cancelled', this.quit);

    this.$router.push({ path: `/patient/${this.patientId}` });
  }*/

  /**
   * On created
   * - create analysis instance
   */
  async created() {
    await this.checkAndSetup();
  }

  async beforeDestroy() {
    if (!this.$pdc.analysis!.manifestIsTouched || this.patientId !== this.$pdc.analysis!.entityCommand?.patientId) {
      if (this.$pdc.analysis!.entityCommand?.patientId) {
        await this.$pdc.analysis!.configurePatient(this.$pdc.analysis!.entityCommand?.patientId);
      } else {
        this.$pdc.analysis!.clean();
      }
    }
  }
}
